import React from "react";

const Separator = ({ doc }) => {
  const { separator_line_required, background_color } = doc?.primary || {};
  const separatorStyle = { backgroundColor: background_color || "white" };

  return (
    <div className="row justify-content-center pb-5 pt-4 no-gutters" style={separatorStyle}>
      {separator_line_required && <div className="col-2 border-top" />}
    </div>
  );
};

export default Separator;
